import React, { useEffect, useState } from "react";
import { Alert } from "react-bootstrap";
import { Link } from "react-router-dom";
import { fetchMyReports } from "../../services/api";
import Loader from "../common/Loader";
import "../common/Account.css";

const MyReports = () => {
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const load = async () => {
      setLoading(true);
      try {
        const res = await fetchMyReports();
        setList(Array.isArray(res?.data) ? res.data : []);
      } catch (err) {
        setError(err.message || "Failed to load reports");
      } finally {
        setLoading(false);
      }
    };
    load();
  }, []);

  return (
    <div className="account-page">
      {loading && <Loader fullPage message="Loading reports..." />}
      <div className="coustom_container">
        <h1>My Reports</h1>
        {error && <Alert variant="danger">{error}</Alert>}
        <div className="account-card">
          {!loading && list.length === 0 && (
            <p className="text-muted mb-0">No reports available yet.</p>
          )}
          {list.map((b) => (
            <div key={b._id} className="booking-item">
              <h5>
                Booking {b.bookingId || b._id}{" "}
                <Link to={`/my-bookings/${b._id}`} className="small">
                  View booking
                </Link>
              </h5>
              <p className="text-muted mb-2">
                {b.bookingDate} · {b.bookingTime}
              </p>
              <ul className="mb-0">
                {(b.reports || []).map((r, idx) => (
                  <li key={idx}>
                    {r.name || "Report"}{" "}
                    {r.link ? (
                      <a href={r.link} target="_blank" rel="noopener noreferrer">
                        Download
                      </a>
                    ) : null}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default MyReports;
